var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getAppId
    ? _c(
        "div",
        [
          _c(
            "v-facebook-login",
            {
              attrs: {
                "app-id": _vm.getAppId,
                version: "v10.0",
                "sdk-locale": "en_US",
                "login-options": {
                  scope: "user_birthday,email",
                  return_scopes: true,
                },
              },
              on: {
                "sdk-init": _vm.handleSdkInit,
                login: _vm.onLoginFacebook,
                logout: _vm.onLogoutFacebook,
              },
              model: {
                value: _vm.model,
                callback: function ($$v) {
                  _vm.model = $$v
                },
                expression: "model",
              },
            },
            [
              _c("template", { slot: "logo" }, [
                _c("img", {
                  staticClass: "img-fb",
                  attrs: {
                    src: "https://static.xx.fbcdn.net/rsrc.php/v3/yN/r/szGrb_tkxMW.png",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("template", { slot: "login" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation("private_sale.btnFacebookLogin")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("template", { slot: "logout" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation("private_sale.btnFacebookLogout")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("template", { slot: "working" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation("private_sale.btnFacebookLoading")) +
                    "\n    "
                ),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }